// Single source of truth for property-type classification + labels.
//
// These lists were copy-pasted across 8 components; adding a type meant
// editing every copy, and a missed file silently broke the map pin color
// or the agreement's Residential/Commercial classification. Centralised
// here so a new type — like the India-specific LAND types below — is a
// one-line change that every screen reads consistently.

export const RES_TYPES = ["apartment", "independent_house", "villa", "pg_room"];

// Commercial includes income-leased LAND types (agri land, farmhouse,
// open plot, godown). They reuse the existing commercial behaviour:
// purple map pin, area in sq.ft, no furnishing field.
export const COM_TYPES = [
  "office", "shop", "showroom", "warehouse", "clinic", "coworking", "industrial",
  "agri_land", "farmhouse", "plot", "godown",
];

export const isCommercial = (pt) => COM_TYPES.includes(pt);
export const isKnownType = (pt) => RES_TYPES.includes(pt) || COM_TYPES.includes(pt);

// [i18n key, English fallback] per type. The fallback means a missing
// translation still reads cleanly instead of showing the raw enum.
const FULL = {
  apartment: ["ptApartment", "Apartment"],
  independent_house: ["ptIndependentHouse", "Independent House"],
  villa: ["ptVilla", "Villa"],
  pg_room: ["ptPgRoom", "PG Room"],
  office: ["ptOffice", "Office"],
  shop: ["ptShop", "Shop"],
  showroom: ["ptShowroom", "Showroom"],
  warehouse: ["ptWarehouse", "Warehouse"],
  clinic: ["ptClinic", "Clinic"],
  coworking: ["ptCoworking", "Coworking"],
  industrial: ["ptIndustrial", "Industrial"],
  agri_land: ["ptAgriLand", "Agricultural Land"],
  farmhouse: ["ptFarmhouse", "Farm House"],
  plot: ["ptPlot", "Open Plot / Land"],
  godown: ["ptGodown", "Godown / Storage"],
};

// Full label — used by property cards, detail badges, the form picker.
// A custom "Other" value (not in FULL) is shown exactly as the landlord
// typed it.
export const ptLabel = (pt, t = {}) => {
  const e = FULL[pt];
  if (!e) return pt;
  return (t && t[e[0]]) || e[1];
};

// Short label for map price-bubble pins (kept terse so the bubble fits,
// e.g. "Cowork · ₹10K"). Falls back to null for residential / unknown so
// callers can decide whether to show a type prefix at all.
const SHORT = {
  office: "Office", shop: "Shop", showroom: "Showroom", warehouse: "Warehouse",
  clinic: "Clinic", coworking: "Cowork", industrial: "Industry",
  agri_land: "Agri Land", farmhouse: "Farm House", plot: "Plot", godown: "Godown",
};
export const ptShort = (pt) => SHORT[pt] || null;
